import TaskStatusBadge from 'components/atoms/task_status_badge';
import moment from 'moment';
import React from 'react';
import { BiddingData, TaskData } from 'store/modules/management_store/types';
import SelectButton from 'components/atoms/select_button';
import { BadgesTasks } from './styles';

interface DataTableItem {
  id: number;
  bidding: BiddingData;
  deadline: string;
  status: string;
  title: string;
  publicBodyName: string;
  responsibleName: string;
  commentsNumber: number;
  attachmentsNumber: number;
  currentCompany: number;
  isChecked: boolean;
}

const ICON_GROW = 0;
const ID_GROW = 0;
const DEADLINE_GROW = 0;
const STATUS_GROW = 1;
const TITLE_GROW = 3;
const PUBLIC_BODY_GROW = 6;
const RESPONSIBLE_GROW = 3;
const BUTTON_GROW = 0;
const SELECT_GROW = 0;

export const datatableData = (
  taskList: Array<TaskData>,
  currentCompany: number,
  selectedProgress: Array<number>,
  source: string = 'management',
) => {
  return taskList.map((task) => {
    const isChecked = selectedProgress.includes(task.id);
    return {
      id: task.id,
      bidding: task.bidding,
      deadline: task.deadline,
      status: task.status_task_id,
      title: task.title,
      publicBodyName:
        source === 'details'
          ? task.description
          : task.bidding?.public_body?.nome ?? 'Licitação indisponível',
      responsibleName: task.responsible.nome,
      commentsNumber: task.task_event_comments?.length || 0,
      attachmentsNumber: task.bidding_attachments?.length || 0,
      currentCompany,
      isChecked,
    };
  });
};

export const datatableColumns = (
  taskList: Array<TaskData>,
  setSelectedTaskId: React.Dispatch<React.SetStateAction<number>>,
  toggleSelected: (id: number) => void,
  source: string = 'management',
) => {
  return [
    {
      name: '',
      width: '80px',
      sortable: true,
      selector: (data: DataTableItem) => data.id,
      center: true,
      grow: SELECT_GROW,
      cell: (data: DataTableItem) => (
        <div
          className="databalloon"
          aria-label={data.isChecked ? 'Remover da seleção' : 'Selecionar licitação'}
          data-balloon-pos="right"
        >
          <SelectButton
            id={data.id}
            isChecked={data.isChecked}
            toggleSelected={toggleSelected}
            text=""
          />
        </div>
      ),
    },
    {
      name: '',
      width: '45px',
      sortable: true,
      selector: (data: DataTableItem) => data.id,
      center: true,
      grow: ICON_GROW,
      cell: (data: DataTableItem) => (
        <BadgesTasks className="d-flex flex-column">
          <span className="badge badge-dark d-flex align-items-center mb-1">
            <span className="material-icons">attach_file</span>
            {data.attachmentsNumber}
          </span>
          <span className="badge badge-dark">
            <span className="material-icons">question_answer</span>
            {data.commentsNumber}
          </span>
        </BadgesTasks>
      ),
    },
    {
      name: '#',
      sortable: true,
      width: '80px',
      selector: (data: DataTableItem) => data.id,
      grow: ID_GROW,
      cell: (data: DataTableItem) => <div>{data.id}</div>,
    },
    {
      name: 'DATA',
      sortable: true,
      width: '100px',
      selector: (data: DataTableItem) => data.deadline,
      ignoreRowClick: true,
      grow: DEADLINE_GROW,
      cell: (data: DataTableItem) => <div>{moment(data.deadline).format('DD/MM/YYYY HH:mm')}</div>,
    },
    {
      name: 'STATUS',
      sortable: true,
      grow: STATUS_GROW,
      selector: (data: DataTableItem) => data.status,
      cell: (data: DataTableItem) => (
        <TaskStatusBadge deadline={data.deadline} status={data.status} />
      ),
    },
    {
      name: 'TAREFA',
      sortable: true,
      selector: (data: DataTableItem) => data.title,
      wrap: true,
      grow: TITLE_GROW,
      cell: (data: DataTableItem) => <div className="font-weight-bold">{data.title}</div>,
    },
    source === 'management'
      ? {
          name: 'ÓRGÃO',
          wrap: true,
          sortable: true,
          grow: PUBLIC_BODY_GROW,
          selector: (data: DataTableItem) => data.publicBodyName,
          cell: (data: DataTableItem) => (
            <div>
              <div className="m-0 font-weight-bold">{data.publicBodyName}</div>
              {data.bidding?.orgao_cidade && data.bidding?.orgao_estado && (
                <div>
                  {data.bidding.orgao_cidade}/{data.bidding.orgao_estado}
                </div>
              )}
              <button
                type="button"
                className="btn btn-sm btn-link p-0"
                disabled={!data.bidding}
                onClick={() =>
                  window.open(
                    `/minhas_licitacoes/management/${data.bidding?.id}/${data.currentCompany}`,
                    `management`,
                  )
                }
              >
                {data.bidding?.edital}
              </button>
            </div>
          ),
        }
      : {
          name: 'DESCRIÇÃO',
          wrap: true,
          sortable: true,
          grow: PUBLIC_BODY_GROW,
          selector: (data: DataTableItem) => data.publicBodyName,
          cell: (data: DataTableItem) => (
            <div className="m-0 font-weight-bold">{data.publicBodyName}</div>
          ),
        },
    {
      name: 'RESPONSÁVEL',
      center: true,
      wrap: true,
      sortable: true,
      grow: RESPONSIBLE_GROW,
      selector: (data: DataTableItem) => data.responsibleName,
      cell: (data: DataTableItem) => <div>{data.responsibleName}</div>,
    },
    {
      name: '',
      width: '120px',
      center: true,
      allowOverflow: true,
      grow: BUTTON_GROW,
      cell: (data: DataTableItem) => (
        <button
          type="button"
          className="btn btn-sm btn-primary text-white"
          onClick={() => setSelectedTaskId(data.id)}
        >
          Visualizar
        </button>
      ),
    },
  ];
};
